// extracted by mini-css-extract-plugin
export default {"about_container":"About_about_container__2Q45P","about_inner":"About_about_inner__9yJBn","about_heading":"About_about_heading__1l37l","about_details":"About_about_details__y00Jd"};